"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=EventInterface.js.map